import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetShapeRequest } from "services/modules/Wrappers/shapes";
import { detailsData } from "./details";

const WrapsVariantsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  wrapsOptionsListArray,
  selectedRow,
  colorsList,
  can_create,
  type,
  options,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  const [wrapId, setWrapId] = useState();

  const shapesList = useSelector((state) => state.shapes.shapes);

  const dispatch = useDispatch();

  useEffect(() => {
    // const filteredData = wrapsOptionsListArray?.find((ele) => ele?.id == selectedRow?.formikData?.values?.wrap_id)
    setWrapId(selectedRow?.formikData?.values?.wrap_id);
  }, [selectedRow?.formikData?.values?.wrap_id]);

  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("wrappers_wrap_variants.details"),
            data: {
              list: detailsData({ data: details, t }),
              checkBox: [
                {
                  checked: details?.track_inventory,
                  label: t("wrappers_wrap_variants.track_inventory"),
                },
                {
                  checked: details?.purchasable,
                  label: t("wrappers_wrap_variants.purchasable"),
                },
              ],
            },
          }}
          table={{
            list: data, // data
            listTitle: t("wrappers_wrap_variants.title"), //title
            createBtnTitle: can_create && t("wrappers_wrap_variants.add"), // action
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "localized_data.en.name",
                Header: t("wrappers_wrap_variants.name_en"),
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("wrappers_wrap_variants.name_ar"),
                sort: true,
              },
              {
                accessor: "wrap",
                Header: t("wrappers_wrap_variants.wrap"),
                sort: true,
              },
              {
                accessor: "shape.name",
                Header: t("wrappers_wrap_variants.shape"),
                sort: true,
              },
              {
                accessor: "color.name",
                Header: t("wrappers_wrap_variants.color"),
                sort: true,
              },
              {
                accessor: "count_on_hand",
                Header: t("wrappers_wrap_variants.quantity"),
                sort: true,
              },
              {
                accessor: "price",
                Header: t("wrappers_wrap_variants.price"),
                sort: true,
              },
              {
                accessor: "price_after_discount",
                Header: t("wrappers_wrap_variants.price_after_discount"),
                sort: true,
              },
              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t(
              "wrappers_wrap_variants.search_placeholder",
            ),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list ...
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            // lw mafesh id add mafesh values -------- lw fe id yb2a edit values
            initialValues: !id
              ? { track_inventory: false, purchasable: false }
              : initialValues(details, supportedLang),
            structure: () => structure(options, t),
            validationSchema: validationSchema(wrapId),
            deleteFun: deleteFun,
            title: id
              ? t("wrappers_wrap_variants.edit")
              : t("wrappers_wrap_variants.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default WrapsVariantsTemplate;
